var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7.25C7 4.48858 9.23858 2.25 12 2.25C14.7614 2.25 17 4.48858 17 7.25V9.07501C18.7117 9.42245 20 10.9357 20 12.75V18.25C20 20.3211 18.3211 22 16.25 22H7.75C5.67894 22 4 20.3211 4 18.25V12.75C4 10.9357 5.28833 9.42246 7 9.07501V7.25ZM8.5 9H15.5V7.25C15.5 5.317 13.933 3.75 12 3.75C10.067 3.75 8.5 5.317 8.5 7.25V9ZM7.75 10.5C6.50736 10.5 5.5 11.5073 5.5 12.75V18.25C5.5 19.4927 6.50736 20.5 7.75 20.5H16.25C17.4927 20.5 18.5 19.4927 18.5 18.25V12.75C18.5 11.5073 17.4927 10.5 16.25 10.5H7.75ZM12 13.25C12.4142 13.25 12.75 13.5858 12.75 14V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V14C11.25 13.5858 11.5858 13.25 12 13.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6ced7c4399a54e13da99edc0573dc0a0.svg";
export { ForwardRef as ReactComponent };